export const ProductsIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 13.335v-6.67a1.25 1.25 0 00-.62-1.079l-5.938-3.455a1.873 1.873 0 00-1.885 0L3.121 5.586A1.25 1.25 0 002.5 6.664v6.67a1.25 1.25 0 00.62 1.08l5.938 3.456a1.875 1.875 0 001.885 0l5.937-3.456a1.25 1.25 0 00.62-1.08z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.695 6.015L10 10.312l7.305-4.297M10 18.125v-7.813"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
